import { useContext, useState } from "react";
import { AppContext } from "../../AppContext";
import Navbar from "../Navbar";
import styles from "./WorkersComponent.module.scss";
import UserImage from "../UserImage";
import WorkersModal from "./WorkersModal";

export default function WorkersComponent() {
  const { allUsers } = useContext(AppContext);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  const handleClick = (user) => {
    setCurrentUser(user);
    setIsModalOpen(true);
  };

  return (
    <>
      <Navbar />
      <div className={styles.container}>
        <div className={styles.user_list}>
          {allUsers.map((user) => (
            <div key={user.id}>
              <button
                className={styles.user}
                onClick={() => {
                  handleClick(user);
                }}
              >
                <UserImage targetUser={user} />
                <span className={styles.name_span}>
                  {user.last_name + " " + user.first_name}
                </span>
              </button>
            </div>
          ))}
        </div>
      </div>
      <WorkersModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        user={currentUser}
      />
    </>
  );
}
